<span [ngClass]="disable ? 'disable-div' : ''">
  <p
    class="custom-btn"
    [ngClass]="getClasses()"
    (click)="onClick()"
    [ngbTooltip]="tooltiptext"
  >
  <span class="name">{{ name }}</span>
</p>
</span>
